import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone: false,
})
export class InitialsPipe implements PipeTransform {
  private readonly splitRegexp: RegExp = /[!@#$%^&*(),.?":{}|<> \-~]/;

  public transform(displayName: string): string {
    if (!displayName) {
      return '';
    }

    const names = displayName
      .trim()
      .split(this.splitRegexp)
      .filter((n) => !!n);

    if (names.length === 0) {
      throw new Error('Name cannot be empty');
    }

    return (names.length === 1 ? names[0].substring(0, 2) : names[0][0] + names[names.length - 1][0]).toUpperCase();
  }
}
